import {Component, HostListener, OnInit} from '@angular/core';
import {CotizacionAgrisViewModel, CotizacionesAgrisFilterViewModel} from '../common/AgrisViewModels';
import {AgrisService, PermisosService} from '../../../services';

@Component({
  selector: 'app-agris-lista-cotizaciones-page',
  templateUrl: './agris-lista-cotizaciones-page.component.html',
  styleUrls: ['./agris-lista-cotizaciones-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisListaCotizacionesPageComponent implements OnInit {

  todas = false;

  // variables para controlar la animacion
  pendientesVisible = true;
  todasVisible = false;

  overlayIsOpen = false;
  propias = false;

  cotizaciones: CotizacionAgrisViewModel[] = [];
  cotizacionesTodas: CotizacionAgrisViewModel[] = [];

  orderItems = ['Fecha de Creación', 'Fecha de Vencimiento'];
  order = 'Fecha de Creación';

  searchTerm = '';

  pendientesLoading = false;
  todasLoading = false;

  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onSearch();
  }

  constructor(
    private agrisService: AgrisService,
    private permServ: PermisosService,
  ) {
    permServ.verificarAccesoDeURL();
  }

  ngOnInit() {
    this.onSearch();
  }

  selectOrder(item) {
    this.order = item;
    this.overlayIsOpen = false;
    this.onSearch();
  }

  onSearch() {
    this.cotizaciones = [];
    this.cotizacionesTodas = [];

    // pendientes
    this.pendientesLoading = true;
    const payload: CotizacionesAgrisFilterViewModel = {
      MisCotizaciones: this.propias,
      OrderByFechaCreacion: this.order === 'Fecha de Creación',
      PageNumber: 0,
      PageSize: 100,
      filter: this.searchTerm,
      Pendientes: true,
    }
    this.agrisService.searchCotizaciones(payload).subscribe(x => {
      this.cotizaciones = x;
      this.pendientesLoading = false;
    }, err => {
      this.pendientesLoading = false;
      this.agrisService.showSnackbarAPIError();
    });

    // todas
    this.todasLoading = true;
    const payloadTodas: CotizacionesAgrisFilterViewModel = {
      MisCotizaciones: this.propias,
      OrderByFechaCreacion: this.order === 'Fecha de Creación',
      PageNumber: 0,
      PageSize: 100,
      filter: this.searchTerm,
      Pendientes: false,
    }
    this.agrisService.searchCotizaciones(payloadTodas).subscribe(x => {
      this.cotizacionesTodas = x;
      this.todasLoading = false;
    }, err => {
      this.todasLoading = false;
      this.agrisService.showSnackbarAPIError();
    });

  }

  switchPage(todas: boolean): void {
    // antes de hacer el cambio, generamos el delay para el cambio de animacion
    if (todas) {
      this.todasVisible = true;
      setTimeout(() => {
        this.pendientesVisible = false;
      }, 400);
    } else {
      this.pendientesVisible = true;
      setTimeout(() => {
        this.todasVisible = false;
      }, 400);
    }
    this.todas = todas;
  }

}





// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-lista-cotizaciones-page/agris-lista-cotizaciones-page.component.ts